import { RESOURCES } from "#customTypes/composedTypes/authTypes"
import { useResourcePermissions } from "#hooks/newHooks/useHasPermission"

/**
 * Centralized auth gate for the workload dashboard.
 * Future rule logic should stay isolated here.
 */
const useCanViewEvaluationWorkloadDashboard = () => {
  const { canRead } = useResourcePermissions(RESOURCES.EVALUATION)
  return canRead
}

export default useCanViewEvaluationWorkloadDashboard
